// 标准事件列表：https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
// vueuse：https://vueuse.org/core/onKeyStroke/#usage
import { onKeyStroke } from '@vueuse/core';
import { activeElementNotInputable } from '@/utils';

export default ({
  beforeKeydown,
  goDown,
  goUp,
  goLeft,
  goRight,
  doCopy,
  doPaste,
  doDel,
  undo,
  redo,
  selectAll,
  increaseBrushWidth,
  minusBrushWidth,
  exitDrawingMode,
}) => {
  onKeyStroke('ArrowDown', e => {
    if (beforeKeydown()) {
      e.preventDefault();
      goDown(e);
    }
  });
  onKeyStroke('ArrowLeft', e => {
    if (beforeKeydown()) {
      e.preventDefault();
      goLeft(e);
    }
  });
  onKeyStroke('ArrowRight', e => {
    if (beforeKeydown()) {
      e.preventDefault();
      goRight(e);
    }
  });
  onKeyStroke('ArrowUp', e => {
    if (beforeKeydown()) {
      e.preventDefault();
      goUp(e);
    }
  });
  onKeyStroke('Delete', e => {
    if (beforeKeydown()) {
      e.preventDefault();
      doDel(e);
    }
  });
  onKeyStroke(['Meta', 'c'], e => {
    if (beforeKeydown()) {
      if (e.metaKey && e.key === 'c') {
        e.preventDefault();
        doCopy(e);
      }
    }
  });
  onKeyStroke(['Meta', 'v'], e => {
    if (beforeKeydown()) {
      if (e.metaKey && e.key === 'v') {
        e.preventDefault();
        doPaste(e);
      }
    }
  });
  onKeyStroke('Backspace', e => {
    if (beforeKeydown()) {
      e.preventDefault();
      doDel(e);
    }
  });
  // onKeyStroke('Undo', e => {
  //   e.preventDefault();
  //   undo(e);
  // });
  // onKeyStroke('Redo', e => {
  //   e.preventDefault();
  //   redo(e);
  // });
  onKeyStroke(['Meta', 'z', 'Shift'], e => {
    if (e.shiftKey && e.metaKey && e.key === 'z') {
      e.preventDefault();
      redo(e);
    }
  });
  onKeyStroke(['Meta', 'z'], e => {
    if (!e.shiftKey && e.metaKey && e.key === 'z') {
      e.preventDefault();
      undo(e);
    }
  });
  onKeyStroke(['Meta', 'a'], e => {
    if (beforeKeydown()) {
      if (!e.shiftKey && e.key === 'a') {
        e.preventDefault();
        selectAll();
      }
    }
  });
  onKeyStroke('=', e => {
    if (activeElementNotInputable()) {
      e.preventDefault();
      increaseBrushWidth();
    }
  });
  onKeyStroke('-', e => {
    if (activeElementNotInputable()) {
      e.preventDefault();
      minusBrushWidth();
    }
  });
  onKeyStroke('Escape', e => {
    if (activeElementNotInputable()) {
      e.preventDefault();
      exitDrawingMode();
    }
  });
};
